export default {
  props: {
    title: {
      type: String,
      deufalt: ''
    }
  }
};
